/* The VIP layout's line icons, one stroke width, drawn in currentColor. */

const PATHS = {
  timer: (
    <>
      <circle cx="12" cy="13.500" r="7.500" />
      <path d="M12 9.500v4l2.500 1.500M9.500 3h5" />
    </>
  ),
  home: <path d="M4 11l8-7 8 7v8a1 1 0 0 1-1 1h-4v-6H9v6H5a1 1 0 0 1-1-1z" />,
  ball: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7.5l4 3-1.5 4.7h-5L8 10.5zM12 3v4.5M21 10.5h-5M3 10.5h5M6.500 19.500l3-4.300M17.500 19.500l-3-4.300" />
    </>
  ),
  ticket: (
    <path d="M5 3h14v18l-2.300-1.500L14.300 21 12 19.500 9.700 21l-2.400-1.500L5 21zM9 8h6M9 12h6" />
  ),
  list: (
    <>
      <rect x="5" y="3.500" width="14" height="17" rx="2" />
      <path d="M9 8.500h6M9 12.500h6M9 16.500h3" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4.500 20.500c1-4.500 4-6 7.500-6s6.500 1.500 7.500 6" />
    </>
  ),
  login: (
    <path d="M10 4h8a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-8M4 12h10M11 8l4 4-4 4" />
  ),
  back: <path d="M15 5l-7 7 7 7" />,
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="M16.500 16.500L21 21" />
    </>
  ),
  chevron: <path d="M9 5l7 7-7 7" />,
  chart: <path d="M5 20V11M12 20V4M19 20v-6" />,
  star: (
    <path d="M12 3.500l2.600 5.400 5.900.8-4.300 4.100 1.100 5.900L12 16.900l-5.300 2.800 1.100-5.900-4.300-4.100 5.900-.8z" />
  ),
  live: (
    <>
      <circle cx="12" cy="12" r="2.500" />
      <path d="M7.500 7.500a6.400 6.400 0 0 0 0 9M16.500 7.500a6.400 6.400 0 0 1 0 9M4.500 4.500a10.600 10.600 0 0 0 0 15M19.500 4.500a10.600 10.600 0 0 1 0 15" />
    </>
  ),
  flame: (
    <path d="M12 3c1 4 6 6 6 11a6 6 0 0 1-12 0c0-2.500 1.500-4 2.500-5 .5 1.500 1.500 2 2 2 0-3 0-5 1.500-8z" />
  ),
  bolt: <path d="M13 3L5 14h6l-1 7 8-11h-6z" />,
  calendar: (
    <>
      <rect x="4" y="5" width="16" height="15" rx="2" />
      <path d="M4 10h16M8 3v4M16 3v4" />
    </>
  ),
};

export type VipIconName = keyof typeof PATHS;

export const VipIcon = ({
  name,
  className,
  size = 18,
}: {
  name: VipIconName;
  className?: string;
  size?: number;
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {PATHS[name]}
  </svg>
);
